import {
    ableProps,
    ablePropsInit,
    exampleProps,
    consistenceProps,
    examplePropsInit,
    consistencePropsInit,
    requiredProps,
    requiredPropsInit,
    validatorProps,
    validatorPropsInit,
    events as baseEvents,
} from '../component-base/props';
export const props = () => [
    ...ableProps,
    ...requiredProps,
    ...validatorProps,
    {
        key: 'placeholder',
        label: '占位文字',
        type: 'string',
        props: {
            maxlength: 16,
            showWordLimit: true,
        },
    },
    {
        key: 'trim',
        label: '是否开启trim',
        type: 'boolean',
    },
    {
        // 约定0为不处理
        key: 'min',
        label: '最少字数',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errMin',
        label: '最少字数提示文案',
        type: 'string',
    },
    {
        // 约定0为不处理
        key: 'max',
        label: '最大字数',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errMax',
        label: '最大字数提示文案',
        type: 'string',
    },
    {
        // 空串表示无正则校验
        key: 'pattern',
        label: '校验正则表达式',
        type: 'string',
    },
    {
        key: 'errPattern',
        label: '正则表达式提示文案',
        type: 'string',
    },
    {
        key: 'ocrConfig',
        label: 'ocr内容配置',
        type: 'ocrConfig',
        props: {},
    },
    ...exampleProps,
    ...consistenceProps,
];

export const init = () => ({
    ...ablePropsInit,
    ...requiredPropsInit,
    ...validatorPropsInit,
    ...examplePropsInit,
    ...consistencePropsInit,
    placeholder: '',
    trim: false,
    min: 0,
    errMin: '',
    max: 0,
    errMax: '',
    pattern: '',
    errPattern: '',
});

export const name = '输入框';

export const component = 'mobile-general-form-input';

export const events = [
    'user-input',
    'change',
    ...baseEvents,
];
